/**
 * Meta Pixel — plugin Vue 2
 *
 * Centraliza a integracao com o Meta Pixel (fbevents.js). Substitui o
 * codigo hardcoded que existia em ChallengeCheckout.vue (Pixel ID
 * 252242255519009 fixo + initFacebookPixel local).
 *
 * Como funciona:
 *  - Le `process.env.VUE_APP_META_PIXEL_ID` em build-time (Vue CLI
 *    inline-define essa variavel se ela existir no .env do client).
 *  - Se a env nao estiver definida, o plugin nao injeta fbevents.js
 *    nem inicializa nada. Site funciona normal sem tracking
 *    (dev local, hom sem pixel de teste, etc.).
 *  - Injeta o snippet uma unica vez (idempotente — verifica window.fbq
 *    e window._fbqInitialized).
 *  - Expoe Vue.prototype.$fbqTrack(event, params) — seguro contra
 *    ad-blockers (se window.fbq nao existir, retorna silencioso).
 *  - PageView SPA: o hook router.afterEach (registrado em main.js)
 *    dispara PageView a cada navegacao client-side.
 *
 * Conformidade: NAO ha banner de consent de cookies no projeto hoje.
 * Idealmente Pixel so carrega apos opt-in do usuario (LGPD). Esta
 * limitacao esta documentada em proposta-meta-pixel/README.md como
 * divida tecnica.
 */

let initialized = false;

function injectPixelLib() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.fbq) return; // ja injetado por algum outro caminho
  const fbq = function() {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
  const s = document.createElement('script');
  s.id = 'fb-pixel-lib';
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
}

function initPixelOnce(pixelId) {
  if (initialized) return;
  if (!pixelId) return;
  if (typeof window === 'undefined') return;

  injectPixelLib();

  if (typeof window.fbq !== 'function') return;

  if (!window._fbqInitialized) {
    try {
      window.fbq('init', pixelId);
      window._fbqInitialized = true;
    } catch (e) {
      // silencioso — nao quebra UI
    }
  }

  initialized = true;
}

/**
 * Plugin Vue: registra $fbqTrack e dispara init na primeira chamada.
 *
 * `$fbqTrack(event, params?)` eh idempotente / seguro:
 *  - Se a env VUE_APP_META_PIXEL_ID nao existir, no-op.
 *  - Se ad-blocker bloqueou fbevents.js, no-op.
 *  - Erros internos do fbq sao engolidos pra nao quebrar UI.
 */
export default {
  install(Vue) {
    const pixelId = process.env.VUE_APP_META_PIXEL_ID || null;

    // Inicializa cedo (no install), mas tolerante a SSR/missing env.
    initPixelOnce(pixelId);

    Vue.prototype.$fbqTrack = function(event, params) {
      if (!pixelId) return;
      if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
      try {
        if (params) window.fbq('track', event, params);
        else window.fbq('track', event);
      } catch (e) {
        // silencioso
      }
    };

    // Helper pra paginas que precisam reagir ao primeiro mount (ex: SPA
    // navegacao que carrega component tarde).
    Vue.prototype.$fbqIsAvailable = function() {
      return !!pixelId && typeof window !== 'undefined' && typeof window.fbq === 'function';
    };
  },
};
